import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import { trackUncaughtErrors } from './app/track_event';

trackUncaughtErrors();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);